export default __webpack_public_path__ + "static/media/emails.1ac61d48.jpg";